import { render } from "./StructView.vue?vue&type=template&id=407201de&ts=true"
import script from "./StructView.vue?vue&type=script&lang=ts"
export * from "./StructView.vue?vue&type=script&lang=ts"

import "./StructView.vue?vue&type=style&index=0&id=407201de&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable});
